import React from 'react';

import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';
import { makeSequence } from 'dpl/shared/utils';

export default function BreederProfilePhotosCarouselSectionSkeleton() {
  return (
    <div className="BreederProfilePhotosCarouselSectionSkeleton container-xxl overflow-hidden">
      <SkeletonBlock className="font-24 mb6" height="1em" width="6em" />
      <ul className="flex gap-16 nr6">
        {makeSequence(3).map(index => (
          <li key={index}>
            <div style={{ width: '80vw' }}>
              <div className="aspect-ratio aspect-ratio--1x1 relative">
                <div className="aspect-ratio--object">
                  <SkeletonBlock className="br3" height="100%" width="100%" />
                </div>
              </div>
              <div className="mt3 mt4-md">
                <SkeletonBlock
                  className="font-18 md:font-20 mb1"
                  height="1em"
                  width="8em"
                />
                <SkeletonBlock className="font-16" height="1em" width="6em" />
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
